import { motion } from "framer-motion";
import { Check } from "lucide-react";

const audiences = [
  "Gym beginners building their first routine",
  "Intermediate lifters tracking progressive overload",
  "Home workout enthusiasts",
  "People building daily movement habits",
  "Anyone who wants to see real progress",
];

const WhoIsItFor = () => {
  return (
    <section
      data-testid="who-is-it-for-section"
      className="bg-white py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          {/* Left column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5 }}
            className="flex-1"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0D0D0D] tracking-tight mb-5">
              Built for every level.
            </h2>
            <p className="text-base text-[#666] leading-relaxed max-w-md">
              Whether you just started your fitness journey or you've been training for years, FitPulse adapts to you. Simple enough for day one. Powerful enough for year five.
            </p>
          </motion.div>

          {/* Right column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="flex-1 w-full"
          >
            <div className="space-y-4">
              {audiences.map((text, i) => (
                <motion.div
                  key={text}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="flex items-start gap-3 py-3 border-b border-[#F0F0F0] last:border-0"
                >
                  <div className="w-5 h-5 rounded-full bg-[#F5F5F5] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check size={12} className="text-[#0D0D0D]" />
                  </div>
                  <span className="text-sm sm:text-base text-[#0D0D0D] font-medium">{text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhoIsItFor;
